import type { Endpoint } from ".";

export const listProjectAssets: Endpoint = {
  id: "listProjectAssets",
  method: "GET",
  path: "/projects/{project_id}/assets",
  summary: "List project assets",
  description: "Returns every asset across properties in the project.",
  params: [
    {
      name: "project_id",
      in: "path",
      required: true,
      description: "UUID of the project.",
      type: "uuid",
      defaultFromClientId: true,
    },
  ],
};
